// 用户token验证
// import Cookies from "js-cookie"

const TokenKey = "Token"

export function getToken () {
  return localStorage.getItem(TokenKey)
  // return Cookies.get(TokenKey)
}

export function setToken (token) {
  localStorage.setItem(TokenKey, token)
  // Cookies.set('SameSite', 'None')
}

export function removeToken () {
  // return Cookies.remove(TokenKey)
  return localStorage.removeItem(TokenKey)
}
